import React, { useEffect, useState } from 'react'
import { CreateNewsletterStyles } from './Style'
import { Button, Form, RenderFields } from 'components/Form'
import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { useParams } from 'react-router-dom'
import { getNewsletterByIdFetch, uploadImageFileFetch } from 'store/middlewares/newsletter.crud'
import { initialize, reset } from 'redux-form'
import { useDispatch } from 'react-redux'
import { convertFromRaw, EditorState } from 'draft-js'
import { NewsletterVM } from 'models/VM'
import { validate } from '.'
import { useSelector } from 'react-redux'
import { Title as ScreenTitle } from 'components'
import { ScreenStyles } from 'styles/GlobalStyle'
import newsletterHooks from './hooks'

const CreateNewsletter = (props) => {
    const { formname } = newsletterHooks.constants
    const formValues = useSelector(state => state.form.newsletter?.values)
    const params = useParams()
    const dispatch = useDispatch()
    const queryClient = useQueryClient()
    const fields = newsletterHooks.useFields()
    const submitBtns = newsletterHooks.useSubmitBtns()
    const [images, setImages] = useState([]);

    const { mutateAsync: uploadImage } = useMutation({
        mutationFn: async (file) => {
            const { data } = await uploadImageFileFetch(formValues.id, file)
            return data
        }
    })
    const newletterOptions = queryOptions({
        queryKey: [qc.newsletters, params.newsletterID, "edit"],
        queryFn: async () => {
            const { data } = await getNewsletterByIdFetch(params.newsletterID)
            let newsletter = new NewsletterVM(data)
            if (newsletter.content) {
                // let nContent = content.getCurrentContent();
                // this.content = JSON.stringify(convertToRaw(nContent));

                let editorState = JSON.parse(newsletter.content)
                editorState = convertFromRaw(editorState)
                newsletter.content = EditorState.createWithContent(editorState)
                // editorState = draftToHtml(editorState)
                // newsletter.content = EditorState.createWithContent(newsletter.content)
            }
            return newsletter
        },
        enabled: !!params.newsletterID,
        refetchOnWindowFocus: false
    })
    const newsletter = useQuery(newletterOptions)

    useEffect(() => {
        return (() => {
            dispatch(reset(formname))
            dispatch(initialize(formname, {}));
        })
    }, [])

    return (
        <ScreenStyles>
            <ScreenTitle {...props} breadcrumbs={true}>
                <div className='bread-crumbs-title'>
                    <div>{">"}</div>
                    {formValues?.name || "שם הפיצ’ר"}
                </div>
            </ScreenTitle>
            <CreateNewsletterStyles>
                <div className='create-newsletter'>
                    <Form
                        form={formname}
                        title={null}
                        validations={validate}
                        submitBtns={[]}
                        submit={() => { }}
                        initialValues={newsletter?.data}
                    >
                        <div className='news-fileds'>
                            <RenderFields fields={[
                                ...fields, {
                                    name: "content",
                                    component: "editor",
                                    label: "",
                                    uploadImage: uploadImage,
                                    className: "_editor",
                                    disabled: !formValues?.id
                                }]} />
                        </div>
                        <div className='news-submit-actions'>
                            {submitBtns.map((btn) =>
                                <Button
                                    size="small"
                                    disabled={!formValues?.id}
                                    {...btn}
                                    action={() => btn.action(images)}
                                />
                            )}
                        </div>
                    </Form>
                </div>
            </CreateNewsletterStyles>
        </ScreenStyles>
    )
}

export default CreateNewsletter